// Omit questions removed from registration, including stale browser values.
const RETIRED_REGISTRATION_FIELDS = new Set([
  "companyNumber",
  "inspirationUrls",
  "customColorScheme",
  "colorSchemeDetails"
]);

const stripRetiredRegistrationFields = (submission = {}) => Object.fromEntries(
  Object.entries(submission).filter(([key]) => !RETIRED_REGISTRATION_FIELDS.has(key))
);

module.exports = { stripRetiredRegistrationFields };
